import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=06438c44&"
import script from "./MobileMenu.vue?vue&type=script&lang=ts&"
export * from "./MobileMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports